import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import setLevelLivingExpenses from "../objectsEndOfTurn/set_level_living_expenses";

export const buildLifestyleResponses = (cardButtons, currentExpAmt, nbrMonthsPlayed) => {
    let responseArr = [];
    for (let i=0; i<cardButtons.length; i++){
        let closureText = "";
        let newExpAmt = 0;
        let moodPoints = 0;
        const livingExpensesObj = setLevelLivingExpenses(cardButtons[i].activity, nbrMonthsPlayed);
        newExpAmt = livingExpensesObj.estimatedMonthlyExp;
        moodPoints = livingExpensesObj.additionalMoodPoints;
        switch (cardButtons[i].activity){
            case 1:
                closureText =  "You've chosen the least expensive lifestyle option. ";
                break;
            case 2:
                closureText = "You've chosen a lifestyle option that is not too expensive. ";
                break;
            case 3:
                closureText = "You've chosen a lifestyle option that is somewhat expensive. ";
                break;
            case 4:
                closureText = "You've chosen the most expensive lifestyle option. ";
                break;
            default:
                break;
        }
        closureText +=  "Your current monthly Misc. Expense amount is " + doubleToStringMonthly(currentExpAmt) + 
                    " and your new monthly expense amount will be " + doubleToStringMonthly(newExpAmt);
        const itemDesc = "Food, Clothes, Personal Items, etc.";
        let responseObj =  {btnText: cardButtons[i].btnText, rltnshpScore: +0,
            closureText: closureText, category: 'expense', on: 'Misc Expenses', type: 'flat', 
            itemDesc: itemDesc,  duration: '-1', replaceAmtSw: true, triggerCondition: "", deleteCondition: "",
            deleteClass: "", moodPoints: moodPoints, value: newExpAmt, linkTo: ""};
        responseArr.push(responseObj); 
    }
           
    return responseArr;
   
}
export default buildLifestyleResponses;

